import React from 'react';
import { useTranslation } from 'react-i18next';
import { isHelixAndLearningHub } from 'utils/helix';
import { useFetchUserAnalysisSkillsContent } from 'actions/users';
import { RelatedSkillContentButton, SkillContentList } from 'screens/UserSkills';
import Stack from 'components/Stack';
import Modal from 'components/Modal';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Box from 'components/Box';
import StickyButtonPanel from 'components/StickyButtonPanel';
import Button from 'components/Button';
import Panel from 'components/Panel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserSkillContentModal(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    skillId = _ref.skillId,
    skillName = _ref.skillName,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchUserAnalysis = useFetchUserAnalysisSkillsContent({
      userId: userId,
      skillId: skillId,
      enabled: isHelixAndLearningHub && !!skillId
    }),
    linkedContent = _useFetchUserAnalysis.items,
    isLinkedContentError = _useFetchUserAnalysis.isError,
    isLinkedContentLoading = _useFetchUserAnalysis.isLoading;
  var hasContent = (linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.length) > 0;
  return /*#__PURE__*/_jsx(Modal, {
    onRequestClose: onClose,
    "aria-labelledby": titleId,
    width: "extraWide",
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      overflow: "visible",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        sticky: true,
        title: t('skills_title_recommended_content_for', {
          name: skillName
        }),
        titleId: titleId,
        onClose: onClose
      }), /*#__PURE__*/_jsx(Box, {
        mt: "-m",
        position: "relative",
        z: "flat",
        role: "group",
        "aria-labelledby": titleId,
        mb: "m",
        children: /*#__PURE__*/_jsx(Panel, {
          children: /*#__PURE__*/_jsx(Stack, {
            spacing: "m",
            children: /*#__PURE__*/_jsx(SkillContentList, {
              isCurrentUser: isCurrentUser,
              skillName: skillName,
              isLoading: isLinkedContentLoading,
              isError: isLinkedContentError,
              linkedContent: linkedContent
            })
          })
        })
      }), /*#__PURE__*/_jsxs(StickyButtonPanel, {
        children: [hasContent && /*#__PURE__*/_jsx(RelatedSkillContentButton, {
          name: skillName,
          size: "default"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: t('actions_close')
        })]
      })]
    })
  });
}
export default UserSkillContentModal;